import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Form,
  Button,
  Badge,
  Alert,
  Table,
} from "react-bootstrap";

const Documente = ({ comenziSelectata, deschideDocumente }) => {
  const [comanda, setComanda] = useState(null);
  const [reaf, setReaf] = useState(false);
  const [mesaj, setMesaj] = useState("");
  const [nrFactura, setNrFactura] = useState("");
  const [dataFactura, setDataFactura] = useState("");
  const [codUit, setCodUit] = useState("");
  const [dataUit, setDataUit] = useState("");
  const [nrCmr, setNrCmr] = useState("");
  const [transportator, setTransportator] = useState("");
  const [dataCmr, setDataCmr] = useState("");
  const [dataDeclaratie, setDataDeclaratie] = useState("");
  const [semnat, setSemnat] = useState("nu");
  const [fisierFactura, setFisierFactura] = useState(null);
  const [fisierUit, setFisierUit] = useState(null);
  const [fisierCmr, setFisierCmr] = useState(null);
  const [fisierDeclaratie, setFisierDeclaratie] = useState(null);

  useEffect(() => {
    if (comenziSelectata) citescComanda();
  }, [comenziSelectata, reaf]);

  const citescComanda = async () => {
    const obPromise = await fetch(`/comanda/${comenziSelectata.id}`);
    const date = await obPromise.json();
    setComanda(date);
    setNrFactura(date.factura?.numar || "");
    setDataFactura(date.factura?.data || "");
    setCodUit(date.uit?.cod || "");
    setDataUit(date.uit?.data || "");
    setNrCmr(date.cmr?.numar || "");
    setTransportator(date.cmr?.transportator || "");
    setDataCmr(date.cmr?.data || "");
    setDataDeclaratie(date.declaratie?.data || "");
    setSemnat(date.declaratie?.semnat || "nu");
  };

  // Returneaza lista de fisiere - compatibil cu formatul vechi (fisier) si nou (fisiere)
  const getFisiere = (subdoc) => {
    if (!subdoc) return [];
    if (subdoc.fisiere && subdoc.fisiere.length > 0) return subdoc.fisiere;
    if (subdoc.fisier) return [subdoc.fisier];
    return [];
  };

  const salveazaDocument = async (tipDoc, dateDoc) => {
    // Construim obiectul cu dot notation
    // ex: { "factura.numar": "FCT-001", "factura.data": "..." }
    // Firestore actualizeaza DOAR aceste campuri, fisierele raman intacte
    const updateData = {};
    Object.keys(dateDoc).forEach((key) => {
      updateData[`${tipDoc}.${key}`] = dateDoc[key];
    });

    await fetch(`/actualizez/${comenziSelectata.id}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updateData),
    });
    setMesaj(`${tipDoc} salvat!`);
    setTimeout(() => setMesaj(""), 3000);
    setReaf(!reaf);
  };

  const incarcaFisier = async (tipDoc, fisiere) => {
    if (!fisiere || fisiere.length === 0) {
      alert("Selectati cel putin un fisier!");
      return;
    }
    const formData = new FormData();
    for (let i = 0; i < fisiere.length; i++) {
      formData.append("fisier", fisiere[i]);
    }
    await fetch(`/uploaddoc/${comenziSelectata.id}/${tipDoc}`, {
      method: "POST",
      body: formData,
    });
    setMesaj(`${fisiere.length} fisier(e) incarcate pentru ${tipDoc}!`);
    setTimeout(() => setMesaj(""), 3000);
    const obPromise = await fetch(`/comanda/${comenziSelectata.id}`);
    const date = await obPromise.json();
    setComanda(date);
  };

  // Afiseaza lista de fisiere cu link de vizualizare
  const ListaFisiere = ({ subdoc, tipDoc }) => {
    const lista = getFisiere(subdoc);
    if (lista.length === 0) return null;
    return (
      <div className="mt-2">
        <small className="text-muted">Fisiere incarcate:</small>
        <ul className="mb-0 ps-3">
          {lista.map((f, i) => (
            <li key={i} className="d-flex align-items-center gap-2">
              <a href={`/documente/${f}`} target="_blank" rel="noreferrer">
                {f.split("_").slice(2).join("_") || f}
              </a>
              <Button
                variant="outline-danger"
                size="sm"
                onClick={async () => {
                  await fetch(
                    `/stergfisier/${comenziSelectata.id}/${tipDoc}/${f}`,
                    {
                      method: "DELETE",
                    },
                  );
                  setReaf(!reaf);
                }}
              >
                ✕
              </Button>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const nrDoc = (c) => {
    let nr = 0;
    if (c.factura?.numar) nr++;
    if (c.uit?.cod) nr++;
    if (c.cmr?.numar) nr++;
    if (c.declaratie?.semnat === "da") nr++;
    return nr;
  };

  const [lista, setLista] = useState([]);

  useEffect(() => {
    if (!comenziSelectata) {
      fetch("/comenzi")
        .then((r) => r.json())
        .then(setLista);
    }
  }, [comenziSelectata]);

  if (!comenziSelectata) {
    return (
      <>
        <h2 className="mb-3">Selectati o comanda</h2>
        <Table striped bordered hover responsive>
          <thead className="table-dark">
            <tr>
              <th>Client</th>
              <th>Tara</th>
              <th>Data</th>
              <th>Dosar</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {lista.map((c) => (
              <tr key={c.id}>
                <td>{c.client}</td>
                <td>{c.tara}</td>
                <td>{c.data_comanda}</td>
                <td>
                  <Badge
                    bg={
                      nrDoc(c) === 4
                        ? "success"
                        : nrDoc(c) > 0
                          ? "warning"
                          : "danger"
                    }
                  >
                    {nrDoc(c)}/4
                  </Badge>
                </td>
                <td>
                  <Button
                    size="sm"
                    variant="primary"
                    onClick={() => deschideDocumente(c)}
                  >
                    Documente
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </>
    );
  }
  return (
    <>
      <h2 className="mb-2">Documente comanda</h2>
      {comanda && (
        <Alert variant="secondary" className="mb-3">
          <strong>{comanda.client}</strong> — {comanda.tara} — Cod TVA:{" "}
          {comanda.cod_tva}
          <br />
          <small>{comanda.produse}</small>
          <div className="mt-1">
            <strong>{comanda.valoare} EUR</strong> | {comanda.data_comanda} |{" "}
            <Badge
              bg={nrDoc === 4 ? "success" : nrDoc > 0 ? "warning" : "danger"}
            >
              Dosar: {nrDoc}/4
            </Badge>
          </div>
        </Alert>
      )}
      {mesaj && <Alert variant="success">{mesaj}</Alert>}

      <Row>
        {/* FACTURA */}
        <Col md={6} className="mb-4">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <strong>Factura fiscala</strong>
              <Badge bg={comanda?.factura?.numar ? "success" : "danger"}>
                {comanda?.factura?.numar || "lipsa"}
              </Badge>
            </Card.Header>
            <Card.Body>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  salveazaDocument("factura", {
                    numar: nrFactura,
                    data: dataFactura,
                    status: "emisa",
                  });
                }}
              >
                <Form.Group className="mb-2">
                  <Form.Label>Numar factura:</Form.Label>
                  <Form.Control
                    type="text"
                    value={nrFactura}
                    onChange={(e) => setNrFactura(e.target.value)}
                    placeholder="ex: FCT-2025-0047"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Data:</Form.Label>
                  <Form.Control
                    type="date"
                    value={dataFactura}
                    onChange={(e) => setDataFactura(e.target.value)}
                  />
                </Form.Group>
                <Button variant="primary" size="sm" type="submit">
                  Salveaza
                </Button>
              </Form>
              <hr />
              <Form.Group className="mb-2">
                <Form.Label>Incarca facturi scanate (multiple):</Form.Label>
                <Form.Control
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  multiple
                  onChange={(e) => setFisierFactura(e.target.files)}
                />
              </Form.Group>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => incarcaFisier("factura", fisierFactura)}
              >
                Incarca fisiere
              </Button>
              <ListaFisiere subdoc={comanda?.factura} tipDoc="factura" />
            </Card.Body>
          </Card>
        </Col>

        {/* UIT */}
        <Col md={6} className="mb-4">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <strong>UIT - e-Transport ANAF</strong>
              <Badge bg={comanda?.uit?.cod ? "success" : "danger"}>
                {comanda?.uit?.cod || "lipsa"}
              </Badge>
            </Card.Header>
            <Card.Body>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  salveazaDocument("uit", {
                    cod: codUit,
                    data: dataUit,
                    status: "activ",
                  });
                }}
              >
                <Form.Group className="mb-2">
                  <Form.Label>Cod UIT:</Form.Label>
                  <Form.Control
                    type="text"
                    value={codUit}
                    onChange={(e) => setCodUit(e.target.value)}
                    placeholder="ex: RO24-UIT-9182736"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Data:</Form.Label>
                  <Form.Control
                    type="date"
                    value={dataUit}
                    onChange={(e) => setDataUit(e.target.value)}
                  />
                </Form.Group>
                <Button variant="primary" size="sm" type="submit">
                  Salveaza
                </Button>
              </Form>
              <hr />
              <Form.Group className="mb-2">
                <Form.Label>Incarca UIT scanat:</Form.Label>
                <Form.Control
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  onChange={(e) => setFisierUit(e.target.files)}
                />
              </Form.Group>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => incarcaFisier("uit", fisierUit)}
              >
                Incarca fisier
              </Button>
              <ListaFisiere subdoc={comanda?.uit} tipDoc="uit" />
            </Card.Body>
          </Card>
        </Col>

        {/* CMR */}
        <Col md={6} className="mb-4">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <strong>CMR - Scrisoare de trasura</strong>
              <Badge bg={comanda?.cmr?.numar ? "success" : "danger"}>
                {comanda?.cmr?.numar || "lipsa"}
              </Badge>
            </Card.Header>
            <Card.Body>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  salveazaDocument("cmr", {
                    numar: nrCmr,
                    transportator,
                    data: dataCmr,
                    status: "semnat",
                  });
                }}
              >
                <Form.Group className="mb-2">
                  <Form.Label>Numar CMR:</Form.Label>
                  <Form.Control
                    type="text"
                    value={nrCmr}
                    onChange={(e) => setNrCmr(e.target.value)}
                    placeholder="ex: CMR-0234"
                  />
                </Form.Group>
                <Form.Group className="mb-2">
                  <Form.Label>Transportator:</Form.Label>
                  <Form.Control
                    type="text"
                    value={transportator}
                    onChange={(e) => setTransportator(e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Data expedierii:</Form.Label>
                  <Form.Control
                    type="date"
                    value={dataCmr}
                    onChange={(e) => setDataCmr(e.target.value)}
                  />
                </Form.Group>
                <Button variant="primary" size="sm" type="submit">
                  Salveaza
                </Button>
              </Form>
              <hr />
              <Form.Group className="mb-2">
                <Form.Label>Incarca CMR scanat (multiple):</Form.Label>
                <Form.Control
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  multiple
                  onChange={(e) => setFisierCmr(e.target.files)}
                />
              </Form.Group>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => incarcaFisier("cmr", fisierCmr)}
              >
                Incarca fisiere
              </Button>
              <ListaFisiere subdoc={comanda?.cmr} tipDoc="cmr" />
            </Card.Body>
          </Card>
        </Col>

        {/* DECLARATIE */}
        <Col md={6} className="mb-4">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <strong>Declaratie de receptie</strong>
              <Badge
                bg={comanda?.declaratie?.semnat === "da" ? "success" : "danger"}
              >
                {comanda?.declaratie?.semnat === "da" ? "confirmata" : "lipsa"}
              </Badge>
            </Card.Header>
            <Card.Body>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  salveazaDocument("declaratie", {
                    data: dataDeclaratie,
                    semnat,
                    status: semnat === "da" ? "confirmata" : "neconfirmata",
                  });
                }}
              >
                <Form.Group className="mb-2">
                  <Form.Label>Data receptiei:</Form.Label>
                  <Form.Control
                    type="date"
                    value={dataDeclaratie}
                    onChange={(e) => setDataDeclaratie(e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Semnat de client:</Form.Label>
                  <Form.Select
                    value={semnat}
                    onChange={(e) => setSemnat(e.target.value)}
                  >
                    <option value="nu">Nu</option>
                    <option value="da">Da - marfa confirmata in UE</option>
                  </Form.Select>
                </Form.Group>
                <Button variant="primary" size="sm" type="submit">
                  Salveaza
                </Button>
              </Form>
              <hr />
              <Form.Group className="mb-2">
                <Form.Label>
                  Incarca declaratie + poze doveditoare (multiple):
                </Form.Label>
                <Form.Control
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  multiple
                  onChange={(e) => setFisierDeclaratie(e.target.files)}
                />
              </Form.Group>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => incarcaFisier("declaratie", fisierDeclaratie)}
              >
                Incarca fisier
              </Button>
              <ListaFisiere subdoc={comanda?.declaratie} tipDoc="declaratie" />
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {nrDoc === 4 && (
        <Alert variant="success">
          <strong>Dosar complet!</strong> Toate documentele sunt inregistrate.
          TVA 0% justificat.
        </Alert>
      )}
    </>
  );
};

export default Documente;
